const WhatsAppButton = () => {
  const phoneNumber = "+923124998010"; // Replace with your number (no + or spaces)
  const message = "Hello! I'm interested in your services."; // Optional

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      style={{
        backgroundColor: "#25D366",
        color: "#fff",
        padding: "10px 15px",
        borderRadius: "50px",
        border: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="20"
        viewBox="0 0 32 32"
        width="20"
        fill="#fff"
      >
        <path d="M16.01 3C9.38 3 4 8.39 4 15.04c0 2.6.83 5.01 2.24 6.98L4 29l7.23-2.23A12.92 12.92 0 0 0 16.01 27C22.64 27 28 21.61 28 15.04S22.64 3 16.01 3zm0 22c-1.92 0-3.73-.5-5.33-1.45l-.38-.23-4.27 1.3 1.36-4.13-.25-.4A9.97 9.97 0 0 1 6 15.04C6 9.93 10.92 6 16.01 6S26 9.93 26 15.04 21.09 25 16.01 25zm5.07-7.62c-.28-.14-1.67-.82-1.93-.91-.26-.1-.45-.14-.63.14s-.72.91-.88 1.1c-.16.18-.32.21-.6.07-.28-.14-1.19-.44-2.27-1.42-.84-.75-1.4-1.68-1.57-1.96-.16-.28-.02-.43.12-.57.12-.12.28-.32.42-.48.14-.16.18-.28.28-.46.1-.18.05-.35-.02-.49-.07-.14-.63-1.5-.86-2.05-.23-.56-.46-.48-.63-.49h-.54c-.18 0-.46.07-.7.35-.24.28-.92.9-.92 2.2s.95 2.56 1.08 2.74c.14.18 1.86 2.84 4.5 3.98.63.27 1.12.43 1.5.55.63.2 1.2.17 1.65.1.5-.07 1.55-.63 1.77-1.24.21-.6.21-1.12.15-1.24-.05-.1-.24-.18-.52-.32z" />
      </svg>
      <span>Chat on WhatsApp</span>
    </button>
  );
};

export default WhatsAppButton;
